import { Axios } from "axios";
import { fetchAuthSession } from 'aws-amplify/auth';
import { awsResources } from "../config/runtimeConfig";


export type API = Axios;

export function createClient(): API {
    const configuredEndpoint = process.env.REACT_APP_REST_API_ENDPOINT || awsResources.RestApiEndpoint;
    const baseURL = new URL(configuredEndpoint);

    // For some reason, axios default content-type is application/x-www-form-urlencoded
    const defaultHeaders = {
        "Content-Type": "application/json",
    };

    const client = new Axios({
        baseURL: baseURL.toString(),
        headers: defaultHeaders,
    });


    client.interceptors.request.use(async (config) => {
        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();
        if (!idToken) {
            throw new Error("We try to attach http authorization headers but we're not logged in.");
        }

        config.headers['Authorization'] = `Bearer ${idToken}`

        return config;
    });

    return client;
}